import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export const useSuperAdminAuthStore = create(
  devtools(
    persist(
      (set, get) => ({
        // Super Admin Auth state
        username: null,
        token: null,
        role: null,
        expiresIn: null,
        isSuperAdmin: false,

        // Actions
        setSuperAdminAuthData: (authData) =>
          set(
            {
              username: authData.username,
              token: authData.token,
              role: authData.role,
              expiresIn: authData.expiresIn,
              isSuperAdmin: true,
            },
            false,
            "set-super-admin-auth-data"
          ),

        setToken: (token) => set({ token }, false, "set-super-admin-token"),

        clearSuperAdminAuthData: () =>
          set(
            {
              username: null,
              token: null,
              role: null,
              expiresIn: null,
              isSuperAdmin: false,
            },
            false,
            "clear-super-admin-auth-data"
          ),

        // Utility getters
        getToken: () => get().token,
        getUsername: () => get().username,
        getRole: () => get().role,
        isSuperAdminAuthenticated: () => get().isSuperAdmin && !!get().token,
      }),
      {
        name: "super-admin-auth-storage",
        partialize: (state) => ({
          username: state.username,
          token: state.token,
          role: state.role,
          expiresIn: state.expiresIn,
          isSuperAdmin: state.isSuperAdmin,
        }),
      }
    ),
    {
      name: "super-admin-auth-store",
    }
  )
);

